import { Provider } from "react-redux";
import React from "react";
import store from "../stores/reduxStore";

import NounProjectNavigation from "../components/nounproject-navigation";

class NounProjectNavigationParent extends React.Component {
    render() {
        // this component exists to pass the redux store to the legacy iconlist component
        return (
            <Provider store={store}>
                <NounProjectNavigation args={this.props.args} />
            </Provider>
        );
    }
}

module.exports = NounProjectNavigationParent;
